import React, { useState } from "react";
import "./Navbar.css";
import logo from "../assets/logo2.png";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);

const goToService = (serviceKey, url) => {
  const section = document.getElementById("services");

  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }

  window.history.pushState({}, "", url);

  setTimeout(() => {
    window.dispatchEvent(
      new CustomEvent("openService", {
        detail: serviceKey,
      })
    );
  }, 400);

  setMenuOpen(false);
  setServicesOpen(false);
};
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
            setMenuOpen(false);
            setServicesOpen(false);
        }
    };

    return (
        <header className="navbar">
            <div className="nav-container">

                <div className="logo">
                    <img
                        src={logo}
                        alt="logo"
                        onClick={() => scrollToSection("hero")}
                    />
                </div>

                <ul className={menuOpen ? "menu active" : "menu"}>

                    <li onClick={() => scrollToSection("hero")}>Почетна</li>
                    <li onClick={() => scrollToSection("about")}>За Нас</li>

                    {/* SERVICES DROPDOWN */}
                    <li
                        className="services-item"
                        onClick={() => setServicesOpen(!servicesOpen)}
                    >
                        Услуги ▾

                         {servicesOpen && (
              <ul className="dropdown">
               <li onClick={() => goToService("lekarski", "/lekarski-uverenija")}>
  Лекарски уверенија
</li>

<li onClick={() => goToService("sistemski", "/sistemski-pregledi")}>
  Систематски прегледи
</li>

<li onClick={() => goToService("prva", "/prva-pomos")}>
  Прва помош на работно место
</li>

<li onClick={() => goToService("psihosocijalni", "/psihosocijalni-rizici")}>
  Психосоцијални ризици
</li>

<li onClick={() => goToService("lab", "/laboratorija")}>
  Лабораторија
</li>
              </ul>
            )}
                    </li>

                    <li onClick={() => scrollToSection("appointment")}>Мој Термин</li>
                    <li onClick={() => scrollToSection("contact")}>Контакт</li>
                </ul>

                <button
                    className="appointment-nav"
                    onClick={() =>
                        document.getElementById("appointment").scrollIntoView({
                            behavior: "smooth"
                        })
                    }
                >
                    Закажи термин
                </button>

                <div
                    className="hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

            </div>
        </header>
    );
}

export default Navbar;